import { pubSub } from '@utils/PubSub';
import { primaryModuleLogo, primaryModuleImage, primaryModuleVideo } from '@utils/ModuleResources';
import VideoControls from '@utils/videoControls';
export default class PrimaryHeroModule {
  constructor(context) {
    this.moduleEl = context;
    const expiration = window.Brooklinen.dyExpiration ?? 5000;
    pubSub.subscribe('dy:primaryHero:init', () => {
      this.initHero();
    });
    setTimeout(() => {
      this.showDefault();
    }, expiration);
  }

  async initHero() {
    const { moduleEl } = this;
    if (window.Brooklinen.primaryHero) {
      const primaryHero = window?.Brooklinen.primaryHero;
      const matchedModuleObj = primaryHero.find((module) => module.general.id == this.moduleEl.dataset.dyId);
      if (matchedModuleObj) {
        let heroLoaded = await this.updateModule(matchedModuleObj);
        if (heroLoaded) {
          setTimeout(() => {
            if (moduleEl.previousElementSibling && moduleEl.previousElementSibling.classList.contains('js-hero-skeleton')) moduleEl.previousElementSibling.remove();
            moduleEl.classList.add('active');
          }, 200);
        }
      }
    }
  }

  showDefault() {
    const primaryHeroModule = document.querySelectorAll('.js-primary-hero-module');
    primaryHeroModule.forEach((hero) => {
      if (hero.previousElementSibling && hero.previousElementSibling.classList.contains('js-hero-skeleton')) hero.previousElementSibling.remove();
      hero.classList.add('active');
    });
  }

  updateSettings(obj) {
    const { moduleEl } = this,
      { dataset } = this.moduleEl,
      { heroLayout, eightNineImage, sixteenNineImage, sixteenNineVideo, seventeenEightImage, seventeenEightVideo, eightNineVideo, textColor, enableVideo, enableVideoControls, enableVideoControlsNative } = obj.general,
      copyEl = this.moduleEl.querySelector('.hero__box');

    let eightNineEl = this.moduleEl.querySelector('.media--eight-nine'),
      wideEl = this.moduleEl.querySelector('.media--wide'),
      heroMediaClassUpdated = false;

    // Update colors

    if (textColor !== '' && copyEl) copyEl.dataset.color = textColor;
    if (textColor === 'white') {
      dataset.bgColor = 'night-sky-dark';
    } else {
      dataset.bgColor = 'magic-hour-extralight';
    }
    // Update images and videos
    if (enableVideo == 'true') {
      const layout = heroLayout !== 'image-left' && heroLayout !== 'image-right' ? 'fullscreen' : 'eight-nine';
      const controls = enableVideoControlsNative == 'true' ? true : false;

      if (this.moduleEl.querySelector('.media--link')) {
        if (seventeenEightVideo !== '') {
          heroMediaClassUpdated = true;
          this.moduleEl.querySelector('.hero__media').classList.add('hero__media--17x8');
        }
        this.moduleEl.querySelector('.media--link').innerHTML = primaryModuleVideo(seventeenEightVideo, sixteenNineVideo, eightNineVideo, seventeenEightImage, sixteenNineImage, eightNineImage, layout, controls);
      }
      if (enableVideoControls && moduleEl) {
        new VideoControls(moduleEl.querySelector('.js--video-controls'), moduleEl);
      }
    } else if (!eightNineEl && !wideEl && enableVideo == 'false' && this.moduleEl.querySelector('.media--link')) {
      this.moduleEl.querySelector('.media--link').innerHTML = primaryModuleImage(eightNineImage);
      eightNineEl = this.moduleEl.querySelector('.media--eight-nine');
      wideEl = this.moduleEl.querySelector('.media--sixteen-nine');
    }

    if (eightNineImage !== '' && eightNineEl) eightNineEl.srcset = eightNineImage;
    if (sixteenNineImage !== '' && heroLayout !== 'image-left' && heroLayout !== 'image-right' && wideEl) wideEl.srcset = sixteenNineImage;

    if (seventeenEightImage !== '' && heroLayout !== 'image-left' && heroLayout !== 'image-right' && seventeenEightImage) {
      if (wideEl) wideEl.srcset = seventeenEightImage;
      moduleEl.querySelector('.hero__media').classList.add('hero__media--17x8');
    } else if (!heroMediaClassUpdated) moduleEl.querySelector('.hero__media').classList.remove('hero__media--17x8');

    // Update Data
    dataset.metaSrc = 'dy';
    dataset.layout = `${heroLayout}`;
  }

  updateContent(obj) {
    const { moduleEl } = this,
      { headline, subcopy, button } = obj.copy,
      headlineEl = this.moduleEl?.querySelector('.hero__headline'),
      headlineDesktopEl = headlineEl?.querySelector('.desktop'),
      headlineMobileEl = headlineEl?.querySelector('.mobile'),
      subcopyEl = this.moduleEl?.querySelector('.hero__subcopy'),
      subcopyDesktopEl = subcopyEl?.querySelector('.desktop'),
      subcopyMobileEl = subcopyEl?.querySelector('.mobile'),
      buttonWrapperEl = this.moduleEl?.querySelector('.hero__buttons');

    // Update headline
    headlineDesktopEl.innerHTML = headline.desktop;
    headlineMobileEl.innerHTML = headline.mobile;
    headlineEl.classList.remove('h1', 'h2', 'h3');
    headlineEl.classList.add(headline.style);
    // Update subcopy
    if (subcopyEl) {
      if (subcopy.desktop !== '') subcopyDesktopEl.innerHTML = subcopy.desktop;
      if (subcopy.mobile !== '') subcopyMobileEl.innerHTML = subcopy.mobile;
      subcopyEl.classList.remove('p1', 'p2', 't1', 't2');
      subcopyEl.classList.add(subcopy.style);
    }

    // Update buttons
    if (buttonWrapperEl) {
      buttonWrapperEl.querySelectorAll('a').forEach((buttonEl, i) => {
        const buttonCopy = i == 0 ? button.copy : button.copy_2;
        const buttonLink = i == 0 ? button.link : button.link_2;
        const buttonStyle = i == 0 ? button.style : button.style_2;

        if (buttonCopy && buttonCopy !== '') buttonEl.innerHTML = buttonCopy;
        if (buttonLink && buttonLink !== '') buttonEl.href = buttonLink;

        if (buttonCopy && buttonLink) {
          buttonEl.classList.remove('button--primary', 'button--primary-inverse', 'button--secondary', 'button--secondary-inverse', 'button--tertiary-b-primary', 'button--tertiary-b-inverse-primary-inverse', 'button--tertiary-a-secondary', 'button--tertiary-a-inverse-secondary-inverse');
          buttonEl.classList.add(buttonStyle);
        }

        //update Logo Image if applicable
        this.updateLogoImage(obj);
      });
    }
  }

  removeAttributes(element) {
    while (element.attributes.length > 0) {
      element.removeAttribute(element.attributes[0].name);
    }
  }

  setAttributes(element, attributes) {
    Object.keys(attributes).forEach((attr) => {
      element.setAttribute(attr, attributes[attr]);
    });
  }

  updateImageLink(obj) {
    const { button } = obj.copy,
      { heroLayout } = obj.general,
      mediaLinkEl = this.moduleEl?.querySelector('.media--link'),
      disabledAttributes = {
        role: 'link',
        'aria-disabled': true,
        href: '#',
      };

    /*
     * As long as the layout isn't a fullbleed background color layout add the
     * link to the image otherwise remove the attributes set in the theme.
     */
    if (heroLayout === 'hero__layout--fullbleed-image' || heroLayout === 'hero__layout--sixteen-nine' || heroLayout === 'hero__layout--seventeen-eight' || heroLayout === 'hero__layout--image-right' || heroLayout === 'hero__layout--image-left') {
      if (mediaLinkEl) mediaLinkEl.href = button.link;
    } else this.setAttributes(mediaLinkEl, disabledAttributes);
  }

  updateLogoImage(obj) {
    if (obj.general?.logoImage) {
      if (!this.moduleEl.querySelector('.hero__logo')) {
        const logoContainer = document.createElement('div');
        logoContainer.classList.add('hero__logo');
        logoContainer.innerHTML = primaryModuleLogo(obj.general?.logoImage);
        this.moduleEl.querySelector('.hero__box').prepend(logoContainer);
      } else if (this.moduleEl.querySelector('.hero__logo')) {
        this.moduleEl.querySelector('.hero__logo').innerHTML = primaryModuleLogo(obj.general?.logoImage);
      }
    } else {
      let logoEl = this.moduleEl?.querySelector('.hero__logo');
      if (logoEl) logoEl.remove();
    }
  }

  updateHeadingFont(obj) {
    const altHeader = obj?.general?.altHeader === 'true';
    if (altHeader) {
      const el = document.querySelector('#primaryHero .hero__headline');
      el.classList.add('alt-font');
    }
  }

  async updateModule(obj) {
    const { moduleEl } = this;
    this.updateSettings(obj);
    this.updateContent(obj);
    this.updateImageLink(obj);
    this.updateHeadingFont(obj);
    // Show DY content
    moduleEl.classList.add('fade-in-slow');
    return true;
  }
}
